import React from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";

interface GGLoaderButtonProps extends ButtonProps {
  isLoading: boolean;
  fullWidth?: boolean,
  variant?: "text" | "outlined" | "contained";
  colorHex?: string;
  disabled?: boolean;
  circularProgressColorHex?: string;
}


const GGLoaderButton: React.FC<GGLoaderButtonProps> = (props: GGLoaderButtonProps) => {
  const { isLoading, colorHex, circularProgressColorHex, ...rest } = props;

  const buttonPropsWithFallback: GGLoaderButtonProps = {
    variant: rest.variant ?? 'contained',
    colorHex: colorHex ?? "#0066b2",
    disabled: rest.disabled ?? false,
    fullWidth: rest.fullWidth ?? false,
    isLoading: isLoading ?? false,
    circularProgressColorHex: circularProgressColorHex ?? "#ffffff",
  };

  return (
     <Button
        className="gg-loader-btn"
        {...rest}
        variant={buttonPropsWithFallback.variant}
        fullWidth={buttonPropsWithFallback.fullWidth}
        disabled={buttonPropsWithFallback.disabled || buttonPropsWithFallback.isLoading}
        sx= {{
            backgroundColor: buttonPropsWithFallback.colorHex,
            color: 'white',
            textTransform: 'none',
            '&:hover': {
                backgroundColor: buttonPropsWithFallback.colorHex,
                opacity: '0.8'
            }
        }}
      >
        {buttonPropsWithFallback.isLoading ? <CircularProgress size={24} thickness={5} sx={{color: buttonPropsWithFallback.circularProgressColorHex}} /> : rest.children}
      </Button>
  );
};

export default GGLoaderButton;
